import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { APPROVAL_BLOCK_DATE, APPROVAL_BLOCK_DATE_SUCCESS, APPROVAL_BLOCK_DATE_ERROR } from '../../actions.js';
import apiCall from '../../../apiCall.js';
import cogoToast from 'cogo-toast';

function* approvalBlockDate({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const { approval_id } = payload.data;

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/admin/block-booking-slot-approval-request/${approval_id}/action`,
      method: 'POST',
      data: payload.data,
      headers: {
        ...filteredHeaders,
      },
    });

    if (response.status === 200 || response.status === 201) {
      cogoToast.success(`${response?.data?.message}`);

      yield put({
        type: APPROVAL_BLOCK_DATE_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(`${response?.response?.data?.message}`);
      yield put({
        type: APPROVAL_BLOCK_DATE_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: APPROVAL_BLOCK_DATE_ERROR, payload: error });
  }
}

export function* watchapprovalBlockDate() {
  yield takeEvery(APPROVAL_BLOCK_DATE, approvalBlockDate);
}

function* approvalBlockDateSaga() {
  yield all([fork(watchapprovalBlockDate)]);
}

export default approvalBlockDateSaga;
